import axios from "../api/axios.js";
import sjcl from "sjcl";
/*
HISTORY CHANGE
01/Apr/2024 VE  - Included axios default withCredentials = true;
*/

// axios.defaults.withCredentials = true; // Ensure cookies are sent with every request

const sjclSecret = process.env.REACT_APP_SJCL_SECRET;

// axios.defaults.withCredentials = true;

export async function getBrandByType(token, productType, storeId = null) {
  const endpoint = process.env.REACT_APP_API_BRAND_BY_TYPE;
  const payload = {
    productType: productType,
  };

  // Add store context if provided
  if (storeId) {
    payload.storeId = storeId;
  }

  try {
    const data = await postToAPI(endpoint, payload, token);
    console.log(`[getBrandByType] Raw API response:`, data);

    if (data && Array.isArray(data) && data.length > 0) {
      const mappedBrands = data.map((brand, index) => ({
        id: index + 1, // Generate sequential IDs since backend doesn't provide them
        title: brand.item || brand.Item, // Handle both lowercase and uppercase
        descr: brand.description || brand.Description,
        imagename: brand.imagename || brand.ImageName,
      }));
      console.log(`[getBrandByType] Mapped brands:`, mappedBrands);
      return mappedBrands;
    } else {
      console.log(`[getBrandByType] No brands found or invalid data format`);
      return [];
    }
  } catch (error) {
    console.error(`[getBrandByType] Error:`, error);
    return [];
  }
}

export async function getCategoryByBrand(
  token,
  productType,
  brand,
  storeId = null
) {
  const endpoint = process.env.REACT_APP_API_CATEGORY_BY_BRAND;
  const payload = {
    brand: brand,
    productType: productType,
  };

  // Add store context if provided
  if (storeId) {
    payload.storeId = storeId;
  }

  try {
    const data = await postToAPI(endpoint, payload, token);
    console.log(`[getCategoryByBrand] Raw API response:`, data);

    if (data && Array.isArray(data) && data.length > 0) {
      const mappedCategories = data.map((category, index) => ({
        id: index + 1, // Generate sequential IDs since backend doesn't provide them
        title: category.item || category.Item, // Handle both lowercase and uppercase
        descr: category.description || category.Description,
        image: category.imagename || category.ImageName || null,
      }));
      console.log(`[getCategoryByBrand] Mapped categories:`, mappedCategories);
      return mappedCategories;
    } else {
      console.log(
        `[getCategoryByBrand] No categories found or invalid data format`
      );
      return [];
    }
  } catch (error) {
    console.error(`[getCategoryByBrand] Error:`, error);
    return [];
  }
}

export async function getProductByCategory(
  token,
  policyId,
  category,
  brand,
  productType,
  storeId = null
) {
  const endpoint = process.env.REACT_APP_API_PRODUCT_BY_CATEGORY;
  const payload = {
    policyId: policyId,
    category: category,
    brand: brand,
    productType: productType,
  };

  // Add store context if provided
  if (storeId) {
    payload.storeId = storeId;
  }

  try {
    const data = await postToAPI(endpoint, payload, token);
    console.log(`[getProductByCategory] Raw API response:`, data);

    if (data && Array.isArray(data) && data.length > 0) {
      const mappedProducts = data.map((product) => ({
        id: product.id,
        title: product.name,
        price: parseFloat(product.price) || 999,
        category: category,
        brand: brand,
        type: productType,
        Image: product.image || null,
        availableQty:
          parseInt(product.availableqty || product.AvailableQty) || 0,
      }));
      console.log(`[getProductByCategory] Mapped products:`, mappedProducts);
      return mappedProducts;
    } else {
      console.log(
        `[getProductByCategory] No products found or invalid data format`
      );
      return [];
    }
  } catch (error) {
    console.error(`[getProductByCategory] Error:`, error);
    return [];
  }
}

export async function createNewOrder(token, payload, storeContext = null) {
  const endpoint = process.env.REACT_APP_API_ORDER_CREATION;

  try {
    const data = await postToAPI(endpoint, payload, token, storeContext);

    if (data || data.length > 0) {
      return data;
    } else {
      return;
    }
  } catch (error) {
    throw error;
  }
}
export async function editOrder(token, payload, storeContext = null) {
  const endpoint = process.env.REACT_APP_API_ORDER_AMENDMENT;

  try {
    const data = await postToAPI(endpoint, payload, token, storeContext);

    if (data || data.length > 0) {
      return data;
    } else {
      return;
    }
  } catch (error) {
    throw error;
  }
}

export async function addToExistingOrder(token, payload, storeContext = null) {
  const endpoint = process.env.REACT_APP_API_ORDER_ADD_TO_EXISTING;

  try {
    // Encrypt the token (required by auth middleware) but keep payload unencrypted
    const encryptedToken = sjcl.encrypt(sjclSecret, JSON.stringify(token));
    
    // Build headers object
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${encryptedToken}`,
    };
    
    // Add store context header if provided
    if (storeContext && storeContext.storeId) {
      headers['x-store-id'] = storeContext.storeId;
    }

    // Use direct axios call for non-encrypted endpoint
    const response = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}${endpoint}`,
      payload,  // Send payload directly, not encrypted
      {
        withCredentials: true,
        headers,
      }
    );

    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized");
    }
    
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function broadcastMessage(token, payload) {
  const endpoint = "broadcastMessage";

  try {
    const data = await postToAPI(endpoint, payload, token);

    if (data || data.length > 0) {
      return data;
    } else {
      return;
    }
  } catch (error) {
    throw error;
  }
}

// WIP: Use sessions to control isAuthenticated
export async function authenticateUser(userId) {
  const endpoint = process.env.REACT_APP_API_AUTH;
  const payload = {
    UserId: userId,
  };

  try {
    const data = await postToAPI(endpoint, payload, "Manuals");
    if (data || data.length > 0) {
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return;
  }
}

export async function loginToServer(userId, agentKey) {
  const endpoint = process.env.REACT_APP_API_LOGIN;
  const payload = {
    UserId: userId,
    AgentKey: agentKey,
  };

  try {
    const data = await postToAPI(endpoint, payload, "Grills");
    if (data || data.length > 0) {
      return data;
    } else {
      return;
    }
  } catch (error) {
    console.log(error);
    return;
  }
}

export async function getInitializationStatus(token, agentId, userId) {
  const endpoint = process.env.REACT_APP_API_INIT;
  const payload = {
    AgentId: agentId,
    UserId: userId,
  };

  try {
    const data = await postToAPI(endpoint, payload, token);

    if (!data || data.length === 0) {
      return [];
    }

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function prepareOrder(token, payload, storeContext = null) {
  const endpoint = process.env.REACT_APP_API_ORDER_PREPARATION;

  try {
    const data = await postToAPI(endpoint, payload, token, storeContext);

    if (data || data.length > 0) {
      return data;
    } else {
      return;
    }
  } catch (error) {
    console.log("Error: ", error);
    throw error;
  }
}

export async function retrieveOrder(token, payload, storeContext = null) {
  const endpoint = process.env.REACT_APP_API_ORDER_RETRIEVAL;

  try {
    const data = await postToAPI(endpoint, payload, token, storeContext);

    if (!data || data.length === 0) {
      return [];
    }

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function validateAvailableInventory(token, payload, storeContext = null) {
  const endpoint = process.env.REACT_APP_API_ORDER_VALIDATION;

  try {
    const data = await postToAPI(endpoint, payload, token, storeContext);

    if (data || data.length > 0) {
      return data;
    } else {
      return;
    }
  } catch (error) {
    throw error;
  }
}

export async function getStores(token) {
  const endpoint = "/api/stores";
  const payload = {}; // Empty payload for stores listing

  try {
    const response = await postToAPI(endpoint, payload, token);

    // Backend returns {success: true, data: [...stores...]}
    if (response && response.data && response.data.length > 0) {
      return response.data.map((store) => ({
        id: store.id,
        title: store.name, // Used for the button click handler
        descr: `${getVesuviusStoreIcon(store.code)} ${store.name}`, // What's displayed on the button
        code: store.code,
        name: store.name,
        emoji: getVesuviusStoreIcon(store.code),
      }));
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching stores:", error);
    throw error;
  }
}

export async function updateUserStore(token, userId, storeId) {
  const endpoint = `/api/user/store/${userId}`;
  const payload = { storeId };

  try {
    const data = await putToAPI(endpoint, payload, token);
    return data;
  } catch (error) {
    console.error("Error updating user store:", error);
    throw error;
  }
}

// Store-aware product type fetching for multi-tenant support
export async function getProductTypesByStore(token, storeId) {
  const endpoint = `${process.env.REACT_APP_API_TYPE}/store/${storeId}`;
  const payload = {}; // Empty payload for store-specific product types

  try {
    // alert(`🔍 API Call: ${endpoint}`);

    const response = await postToAPI(endpoint, payload, token);

    // alert(`📥 Raw Response: ${JSON.stringify(response)}`);
    // alert(`📊 Response Type: ${typeof response}, Is Array: ${Array.isArray(response)}, Keys: ${Object.keys(response)}`);

    // Check if we got the proper encrypted structure
    // if (response && typeof response === 'object' && !Array.isArray(response)) {
    //   alert(`🔍 Response Keys Detail: ${JSON.stringify(Object.keys(response))}`);
    //   if (response.responseData) {
    //     alert(`🔐 Found encrypted responseData (length: ${response.responseData.length})`);
    //   } else {
    //     alert(`❌ Missing responseData - got raw unencrypted response instead`);
    //   }
    // }

    // Debug the postToAPI response structure
    const responseKeys = Object.keys(response);
    // if (responseKeys.length === 0) {
    //   alert(`🔍 Empty response object - checking postToAPI issue`);
    // }

    // Backend returns array of product types directly
    if (response && Array.isArray(response)) {
      const mappedProductTypes = response.map((productType, index) => {
        return {
          id: index + 1, // Generate sequential IDs since we only get Type now
          title: productType.type || productType.Type,
          descr: productType.type || productType.Type,
        };
      });

      // alert(`✅ Mapped ${mappedProductTypes.length} product types: ${JSON.stringify(mappedProductTypes).substring(0, 200)}...`);
      return mappedProductTypes;
    } else {
      alert(`❌ Response is not a valid array, returning empty array`);
      return [];
    }
  } catch (error) {
    alert(`🚨 Error: ${error.message}`);
    throw error;
  }
}

// Helper function for MapleStory SEA world icons (constellation-themed)
function getVesuviusStoreIcon(storeCode) {
  // Legacy tree-themed icons (preserved for rollback)
  /*
  const vesuviusIconMap = {
    terra: "🌳", // Earth tree - Oak/Strong tree
    aqua: "🌊", // Water - Keep wave for water association  
    ignis: "🍁", // Fire - Autumn leaves (fiery colors)
    ventus: "🌿", // Wind - Leaves in the wind
    silva: "🌲", // Forest - Pine/Evergreen tree
  };
  */

  // MapleStory SEA world icons (constellation-themed)
  const mapleWorldIconMap = {
    aquila: "/girl_animation_2/stand1_0.png", // Eagle constellation - girl character sprite
    bootes: "✨", // Herdsman constellation - sparkling star for the guardian
    cassiopeia: "⋆", // Queen constellation - elegant star for royalty
    delphinus: "🌟", // Dolphin constellation - glowing star of the seas
    eridanus: "💫", // River constellation - flowing shooting star
  };

  return mapleWorldIconMap[storeCode?.toLowerCase()] || "✦"; // Default: Four-pointed star
}

// Legacy function for backward compatibility
function getStoreEmoji(storeCode) {
  return getVesuviusStoreIcon(storeCode);
}

export async function postToAPI(endpoint, payload, token, storeContext = null) {
  const encryptedPayload = sjcl.encrypt(sjclSecret, JSON.stringify(payload));
  const encryptedToken = sjcl.encrypt(sjclSecret, JSON.stringify(token));

  try {
    // Build headers object
    const headers = {
      Authorization: `Bearer ${encryptedToken}`,
    };
    
    // Add store context header if provided
    if (storeContext && storeContext.storeId) {
      headers['x-store-id'] = storeContext.storeId;
    }

    const response = await axios.post(
      `${endpoint}`,
      { payload: encryptedPayload },
      {
        withCredentials: true,
        headers,
      }
    );

    // if (response.status === "401" || response.status === "403") {
    //   throw new Error("Unauthorized. Please login again.");
    // }

    // if (response.status === "400") {
    //   throw new Error("Unauthorized. Please login again.");
    // }

    // Check if cookies are present in the response headers
    // const cookies = response.headers["set-cookie"];
    // if (cookies) {
    //   alert("Received cookies:", cookies);
    //   // You can access individual cookies in the 'cookies' array
    // } else {
    //   alert("No cookies received");
    // }

    // CRITICAL: Check for JWT middleware errors BEFORE attempting decryption
    // JWT 403 errors are not encrypted and will cause decryption to fail
    if (response.status === 403 && response.data && response.data.message === 'Access revoked') {
      // Handle session invalidation immediately
      import('../utils/sessionInvalidationHandler').then(({ invalidateSession }) => {
        invalidateSession(response.data.reason);
      }).catch(importError => {
        // Fallback: show alert and redirect
        alert(`🔐 Access Revoked\n\n${response.data.reason || 'Your session has expired.'}\n\nYou will be redirected to login.`);
        window.location.href = '/';
      });
      
      // Throw error to stop further processing
      throw new Error(`Access revoked: ${response.data.reason || 'Session expired'}`);
    }

    // Get the encrypted data from the request body
    const { responseData } = response.data;

    // Decrypt the data
    if (!responseData || responseData.length === 0) {
      return {};
    }
    const decryptedData = sjcl.decrypt(sjclSecret, responseData);

    const parsedJSON = JSON.parse(decryptedData);

    return parsedJSON;
  } catch (error) {
    // Check for 403 Access Revoked errors and handle session invalidation
    if (error.response && error.response.status === 403) {
      const data = error.response.data;
      
      // Check if this is an access revoked error from our JWT middleware (unencrypted)
      if (data && data.message === 'Access revoked') {
        // Import session handler dynamically to avoid circular imports
        import('../utils/sessionInvalidationHandler').then(({ invalidateSession }) => {
          invalidateSession(data.reason);
        }).catch(importError => {
          // Fallback: show alert and redirect
          alert(`🔐 Access Revoked\n\n${data.reason || 'Your session has expired.'}\n\nYou will be redirected to login.`);
          window.location.href = '/';
        });
        
        // Throw a more user-friendly error
        throw new Error(`Access revoked: ${data.reason || 'Session expired'}`);
      } else if (data && data.responseData) {
        // Try to decrypt 403 response to check for access revoked message
        try {
          const decryptedData = sjcl.decrypt(sjclSecret, data.responseData);
          const decryptedJson = JSON.parse(decryptedData);
          
          if (decryptedJson && decryptedJson.message === 'Access revoked') {
            // Import session handler dynamically to avoid circular imports
            import('../utils/sessionInvalidationHandler').then(({ invalidateSession }) => {
              invalidateSession(decryptedJson.reason);
            }).catch(importError => {
              // Fallback: show alert and redirect
              alert(`🔐 Access Revoked\n\n${decryptedJson.reason || 'Your session has expired.'}\n\nYou will be redirected to login.`);
              window.location.href = '/';
            });
            
            // Throw a more user-friendly error
            throw new Error(`Access revoked: ${decryptedJson.reason || 'Session expired'}`);
          }
        } catch (decryptError) {
          // Silent handling of decryption errors for non-session related 403s
        }
      }
    }
    
    // For any other errors, throw them
    throw new Error(error.message || error);
  }
}

export async function putToAPI(endpoint, payload, token) {
  const encryptedPayload = sjcl.encrypt(sjclSecret, JSON.stringify(payload));
  const encryptedToken = sjcl.encrypt(sjclSecret, JSON.stringify(token));

  try {
    const response = await axios.put(
      `${process.env.REACT_APP_SERVER_URL}${endpoint}`,
      { payload: encryptedPayload },
      {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${encryptedToken}`,
        },
      }
    );

    if (response.status === "401" || response.status === "403") {
      throw new Error("Unauthorized");
    }
    // Get the encrypted data from the request body
    const { responseData } = response.data;

    // Decrypt the data
    const decryptedData = sjcl.decrypt(sjclSecret, responseData);

    const parsedJSON = JSON.parse(decryptedData);

    return parsedJSON;
  } catch (error) {
    throw new Error("Unauthorized. Please try again.");
  }
}

// Get store-specific orders for user after store selection
export async function getStoreSpecificOrders(token, storeId, userId) {
  const endpoint = `/api/store/orders`;
  const payload = {
    storeId: storeId,
    userId: userId,
  };

  try {
    console.log(`[getStoreSpecificOrders] Calling endpoint: ${endpoint} with storeId: ${storeId}, userId: ${userId}`);
    const response = await postToAPI(endpoint, payload, token);
    
    console.log(`[getStoreSpecificOrders] Raw API response:`, response);

    // The response structure is { success: true, data: { storeId, userId, currentTimeSlotOrders } }
    if (response && response.data && response.data.currentTimeSlotOrders) {
      return response.data.currentTimeSlotOrders;
    } else {
      // No orders found for this store - return empty object
      console.log(`[getStoreSpecificOrders] No orders found for store ${storeId}`);
      return {};
    }
  } catch (error) {
    console.error(`[getStoreSpecificOrders] Error:`, error);
    throw error;
  }
}

// Get smart store balance recommendation
export async function getStoreBalanceRecommendation(token) {
  const endpoint = `/api/store/balance-recommendation`;
  const payload = {}; // Empty payload

  try {
    console.log(`[getStoreBalanceRecommendation] Calling endpoint: ${endpoint}`);
    
    const response = await postToAPI(endpoint, payload, token);
    
    console.log(`[getStoreBalanceRecommendation] Raw API response:`, response);

    if (response && response.success) {
      return response.data;
    } else {
      console.log(`[getStoreBalanceRecommendation] Invalid response format`);
      return null;
    }
  } catch (error) {
    console.error(`[getStoreBalanceRecommendation] Error:`, error);
    throw error;
  }
}

// Submit user detail amendment for existing order
export async function submitUserDetailAmendment(payload, token) {
  const endpoint = `/api/order/edit-user-details`;

  try {
    const response = await postToAPI(endpoint, payload, token);

    if (response) {
      return {
        success: true,
        data: response
      };
    } else {
      return {
        success: false,
        error: "Invalid response format"
      };
    }
  } catch (error) {
    console.error(`[submitUserDetailAmendment] Error:`, error);
    
    // Handle specific error responses
    if (error.response && error.response.data) {
      return {
        success: false,
        error: error.response.data.error || "User detail amendment failed",
        message: error.response.data.message || error.message,
        details: error.response.data.details
      };
    }
    
    return {
      success: false,
      error: "Network error",
      message: error.message || "Failed to submit user detail amendment"
    };
  }
}
